
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bantuan/akun",
      function () {
        return require("private-next-pages/bantuan/akun.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bantuan/akun"])
      });
    }
  